import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { useDialog } from '../../../../../hooks/use-dialog';
import { useMenu } from '../../../../../hooks/use-menu';
import type { ModifyLineItemData } from '../types';
import { DynamicInvoiceDisableUsageLineItem } from './DynamicInvoiceDisableUsageLineItem';
import { SharedUsageLineItemDialog } from './SharedUsageLineItemDialog';

type ModifyUsageLineItemSectionProps = {
  lineItemId: string;
  customerId: string;
  invoiceId: string;
  lineItemData: ModifyLineItemData;
  disabled?: boolean;
};

export const ModifyUsageLineItemSection: React.FC<ModifyUsageLineItemSectionProps> = ({
  lineItemId,
  customerId,
  invoiceId,
  lineItemData,
  disabled = false,
}) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();
  const editDialog = useDialog();

  const openDialog = (dialog: ReturnType<typeof useDialog>) => {
    handleMenuClose();
    dialog.handleOpen();
  };

  return (
    <div>
      <IconButton
        size="medium"
        onClick={(e) => {
          e.stopPropagation();
          handleMenuOpen(e);
        }}
      >
        <VyIcon icon="DotsMenu" />
      </IconButton>

      <Menu
        anchorEl={anchorElement}
        open={isOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem onClick={() => openDialog(editDialog)}>
          <ListItemIcon>
            <VyIcon icon="Edit" style={{ transform: 'scale(0.8)' }} />
          </ListItemIcon>
          <ListItemText>Edit item</ListItemText>
        </MenuItem>

        <DynamicInvoiceDisableUsageLineItem
          lineItemId={lineItemId}
          disabled={disabled}
          closeMenu={handleMenuClose}
          customerId={customerId}
        />
      </Menu>

      <SharedUsageLineItemDialog
        open={editDialog.isDialogOpen}
        handleClose={editDialog.handleClose}
        lineItemId={lineItemId}
        lineItemData={lineItemData}
        invoiceId={invoiceId}
      />
    </div>
  );
};
